export const ACTION_TYPES = {
	FIXING: 'FIXING',
	INVESTIGATING: 'INVESTIGATING',
}
export const SHIP_CONTAINER_ID = 'Ship'

export const SHIP_WIDTH = 1217.01
export const SHIP_HEIGHT = 883
